import React from 'react';
import PropTypes from 'prop-types';

export const LayoutContext = React.createContext();

const initialState = {
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'ENABLE_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case 'DISABLE_LOADING':
      return {
        ...state,
        isLoading: false,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

export const LayoutProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const setLayoutLoading = (value) => {
    dispatch({ type: value ? 'ENABLE_LOADING' : 'DISABLE_LOADING' });
  };

  return (
    <LayoutContext.Provider value={{ state, dispatch, setLayoutLoading }}>
      {children}
    </LayoutContext.Provider>
  );
};

LayoutProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
